import { useContext } from 'react'
import { SidebarContext } from '../../../contexts/SidebarContext'

import {
  Box,
  Drawer,
  alpha,
  styled,
  // Divider,
  useTheme,
  lighten,
} from '@mui/material'

import SidebarMenu from './SidebarMenu'
import Logo from '../../../../../components/LogoSign'

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        min-width: ${theme.sidebar.width};
        color: ${theme.colors.alpha.trueWhite[70]};
        position: relative;
        z-index: 7;
        height: 100%;
        padding-bottom: 68px;
`
)

/**
 * The scrolling part of the rail.
 *
 * Scrolls on wheel, touch, keyboard and drag, but paints no scrollbar: the
 * rail is a fixed, narrow column and a track down its edge is noise. It
 * replaces react-custom-scrollbars-2 here, which drew a visible thumb and
 * wrapped the menu in two extra divs; the component stays in use elsewhere.
 */
const SidebarScroll = styled(Box)(
  () => `
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
        overscroll-behavior: contain;

        scrollbar-width: none;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
          display: none;
        }
`
)

/**
 * The mark, pinned above the scroll area so it never scrolls out of view.
 *
 * The bottom margin is the mark's own breathing room rather than the menu's:
 * now that the menu scrolls underneath it, its first row would otherwise ride
 * up until it touched the wordmark's descenders.
 */
const SidebarBrand = () => (
  <Box sx={{ flexShrink: 0, mt: 5, mb: 3 }}>
    <Box mx={2} sx={{ width: 52 }}>
      <Logo />
    </Box>
  </Box>
)

function Sidebar() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext)
  const closeSidebar = () => toggleSidebar()
  const theme = useTheme()

  return (
    <>
      <SidebarWrapper
        sx={{
          display: {
            xs: 'none',
            lg: 'flex',
          },
          flexDirection: 'column',
          // The 68px the wrapper reserves at the bottom is the footer's row now.
          pb: 0,
          position: 'fixed',
          left: 0,
          top: 0,
          background:
            theme.palette.mode === 'dark'
              ? alpha(lighten(theme.header.background!, 0.1), 0.5)
              : theme.colors.black.main,
          boxShadow:
            theme.palette.mode === 'dark' ? theme.sidebar.boxShadow : 'none',
        }}
      >
        <SidebarBrand />
        <SidebarScroll>
          {/* <Divider
            sx={{
              mt: theme.spacing(3),
              mx: theme.spacing(2),
              background: theme.colors.alpha.trueWhite[10],
            }}
          /> */}
          <SidebarMenu />
        </SidebarScroll>
        {/* Version marker the design document puts at the foot of the rail. */}
        <Box
          sx={{
            flexShrink: 0,
            px: 3,
            py: 2.5,
            fontSize: 12,
            letterSpacing: 0.2,
            color: theme.colors.alpha.trueWhite[50],
            borderTop: `1px solid ${theme.colors.alpha.trueWhite[10]}`,
          }}
        >
          Bloom Psychologie · beheeromgeving
        </Box>
      </SidebarWrapper>
      <Drawer
        sx={{
          boxShadow: `${theme.sidebar.boxShadow}`,
        }}
        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
        open={sidebarToggle}
        onClose={closeSidebar}
        variant="temporary"
        elevation={9}
      >
        <SidebarWrapper
          sx={{
            display: 'flex',
            flexDirection: 'column',
            pb: 0,
            background:
              theme.palette.mode === 'dark'
                ? theme.colors.alpha.white[100]
                : theme.colors.black.main,
          }}
        >
          <SidebarBrand />
          <SidebarScroll>
            <SidebarMenu />
          </SidebarScroll>
        </SidebarWrapper>
      </Drawer>
    </>
  )
}

export default Sidebar
